import { render, staticRenderFns } from "./BorderControls.vue?vue&type=template&id=5b1953af&scoped=true"
import script from "./BorderControls.vue?vue&type=script&lang=js"
export * from "./BorderControls.vue?vue&type=script&lang=js"
import style0 from "./BorderControls.vue?vue&type=style&index=0&id=5b1953af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1953af",
  null
  
)

export default component.exports